/**
 * KYVERA — single shared scroll-reveal for all .kyvera-fade-in elements
 * across the theme. One IntersectionObserver instance instead of a
 * separate inline <script> per section (smaller payload, fewer listeners).
 * No-ops instantly if the browser lacks IntersectionObserver or the
 * visitor prefers reduced motion (CSS already handles the reduced-motion
 * fallback, this just avoids the unnecessary observer entirely).
 */
(function () {
  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal() {
    var els = document.querySelectorAll('.kyvera-fade-in:not(.is-visible)');
    if (!els.length) return;

    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reveal, { once: true });
  } else {
    reveal();
  }

  // Sections can be added/re-rendered in the theme editor without a full
  // page load — re-scan when that happens.
  document.addEventListener('shopify:section:load', reveal);
})();
